import React from "react";

/**
 * @typedef {import("../../jsdoc/ContractHolderGroup").ContractHolderGroup} ContractHolderGroup
 */

/**
 * HeaderGroupTypeOption Component
 * @param {Object} props
 * @param {ContractHolderGroup} props.contractHolderGroup
 * @param {Function} props.handleChangeGroup
 * @param {Object} props.options
 * @returns {React.JSX.Element}
 */
export default function HeaderGroupTypeOption({ contractHolderGroup, handleChangeGroup, options }) {
  return (
    <table>
      <tbody>
        <tr>
          <td>
            <strong className="set-aside-group-name">{`${contractHolderGroup.group}:`}</strong>
            <label className="set-aside-radio-label">
              <input
                className="set-aside-radio"
                type="radio"
                role="radio"
                name="filterValue"
                onChange={() => handleChangeGroup({ group: contractHolderGroup.group })}
                checked={!options.groupOptions.facet && options.groupOptions.group === contractHolderGroup.group}
              />
              All Contract Holders
            </label>
          </td>

          {contractHolderGroup.setAsidesList.map((setAside) => (
            <td key={setAside.facetSeq}>
              <label className="set-aside-radio-label">
                <input
                  className="set-aside-radio"
                  type="radio"
                  role="radio"
                  name="filterValue"
                  value={setAside.facetSeq}
                  onChange={() => handleChangeGroup({ group: contractHolderGroup.group, facet: setAside.facetName })}
                  checked={
                    options.groupOptions.group === contractHolderGroup.group &&
                    options.groupOptions.facet === setAside.facetName
                  }
                />
                {setAside.facetName}
              </label>
            </td>
          ))}
        </tr>
      </tbody>
    </table>
  );
}
